module.exports = __webpack_public_path__ + "static/homepageListSecond-94a3e2466d7e795e6a452e359eb7f5fa.svg";